/* Kalender, Personenauswahl, Stapel (AUFGABEN-STUFE2.md, Abschnitte 3.4, 3.5, 6.4). Vorlage: docs/app/mockups/Aufgaben-Stufe2-2026-10-12.html */

.meta {
  font-size: 13px;
  color: var(--muted);
}

/* Schwebendes Fenster */
.schwebend {
  position: fixed;
  z-index: 60;
  background: var(--white);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: var(--schatten-3);
  max-height: calc(100vh - 32px);
  overflow: auto;
  color-scheme: light;
}
.schwebendHandy {
  left: 16px;
  right: 16px;
  bottom: 16px;
  top: auto;
  width: auto;
  max-height: calc(100vh - 80px);
}

/* Stapel */
.stapel {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
.kopf {
  display: inline-flex;
  margin-left: -8px;
  border-radius: 50%;
  box-shadow: 0 0 0 2px var(--white);
}
.kopf:first-child {
  margin-left: 0;
}
.mehr {
  align-items: center;
  justify-content: center;
  background: var(--surface);
  color: var(--text);
  font-size: 13px;
  font-weight: 600;
}
.offenKreis {
  display: inline-block;
  border-radius: 50%;
  border: 1.5px dashed #9b968e;
  background: var(--white);
}
.stapelKnopf {
  display: inline-flex;
  align-items: center;
  min-height: var(--target);
  min-width: var(--target);
  padding: 0 6px;
  border: 1px solid transparent;
  border-radius: var(--radius-pill);
  background: none;
  cursor: pointer;
}
.stapelKnopf:hover:not(:disabled) {
  background: var(--surface);
}
.stapelKnopf:disabled {
  cursor: default;
}

/* Chips */
.chips {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 3px 4px 3px 4px;
  padding-right: 12px;
  border-radius: var(--radius-pill);
  background: var(--surface);
  font-size: 14px;
  font-weight: 500;
}
.chip:has(.chipWeg) {
  padding-right: 0;
}
.chipWeg,
.plusPerson,
.fertig,
.textKnopf,
.pfeil {
  font: inherit;
  color: var(--text);
  cursor: pointer;
}
.chipWeg {
  min-width: var(--target);
  min-height: 36px;
  border: 0;
  border-radius: var(--radius-pill);
  background: none;
  font-size: 13px;
}
.chipWeg:hover {
  background: #e4e2de;
}
.plusPerson {
  min-height: var(--target);
  padding: 0 14px;
  border: 1.5px dashed #b5b0a8;
  border-radius: var(--radius-pill);
  background: var(--white);
  font-size: 14px;
  font-weight: 500;
}
.plusPerson:hover {
  border-color: var(--text);
}

/* Liste der Personen */
.personen {
  list-style: none;
  margin: 0;
  padding: 6px;
}
.personZeile {
  display: grid;
  grid-template-columns: 24px 30px 1fr auto;
  align-items: center;
  gap: 10px;
  min-height: var(--target);
  padding: 4px 10px;
  border-radius: 12px;
  cursor: pointer;
}
.personZeile:hover {
  background: var(--surface);
}
.personZeile input {
  width: 20px;
  height: 20px;
  accent-color: var(--black);
}
.personGesperrt {
  opacity: 0.6;
  cursor: default;
}
.personName {
  font-weight: 500;
}
.personenFuss {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px 12px;
  border-top: 1px solid var(--surface);
}
.fertig {
  min-height: var(--target);
  padding: 0 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--white);
  font-weight: 600;
}

/* Datumsknopf */
.kalenderFeld {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.datumKnopf {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: var(--target);
  padding: 0 14px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--white);
  color: var(--text);
  font: 500 14px var(--font);
  cursor: pointer;
  white-space: nowrap;
}
.datumKnopf:hover:not(:disabled) {
  background: var(--surface);
}
.datumKnopf:disabled {
  cursor: default;
  opacity: 0.7;
}
.datumGesetzt {
  font-weight: 600;
}
.datumKlein {
  font-size: 13px;
  padding: 0 10px;
}
.datumZusatz {
  font-size: 13px;
  color: var(--muted);
}
.datumKnopf:focus-visible,
.chipWeg:focus-visible,
.plusPerson:focus-visible,
.fertig:focus-visible,
.stapelKnopf:focus-visible,
.textKnopf:focus-visible,
.pfeil:focus-visible,
.tag:focus-visible,
.schnell button:focus-visible {
  outline: 3px solid var(--focus);
  outline-offset: 2px;
}

/* Kalender */
.kalender {
  display: grid;
  grid-template-columns: 236px 1fr;
}
.schnell {
  list-style: none;
  margin: 0;
  padding: 8px;
  border-right: 1px solid var(--surface);
}
.schnell button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  gap: 8px;
  width: 100%;
  min-height: var(--target);
  padding: 0 10px;
  border: 0;
  border-radius: 10px;
  background: none;
  font: 500 14px var(--font);
  color: var(--text);
  text-align: left;
  cursor: pointer;
}
.schnell button:hover:not(:disabled) {
  background: var(--surface);
}
.schnell button:disabled {
  opacity: 0.45;
  cursor: default;
}
.monat {
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.monatKopf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.monatKnoepfe {
  display: inline-flex;
  align-items: center;
}
.textKnopf {
  min-height: var(--target);
  padding: 0 10px;
  border: 0;
  border-radius: 10px;
  background: none;
  font-size: 14px;
  font-weight: 500;
  align-self: flex-start;
}
.textKnopf:hover {
  background: var(--surface);
}
.pfeil {
  width: var(--target);
  height: var(--target);
  border: 0;
  border-radius: 10px;
  background: none;
  font-size: 20px;
}
.pfeil:hover {
  background: var(--surface);
}
.raster {
  display: grid;
  gap: 2px;
}
.zeile {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}
.wt {
  text-align: center;
  font-size: 13px;
  color: var(--muted);
  padding: 4px 0;
}
.tag {
  position: relative;
  width: 100%;
  min-height: var(--target);
  border: 2px solid transparent;
  border-radius: 10px;
  background: none;
  font: 500 14px var(--font);
  color: var(--text);
  cursor: pointer;
}
.tag:hover:not(:disabled) {
  background: var(--surface);
}
.tag:disabled {
  opacity: 0.35;
  cursor: default;
}
.fremd {
  color: var(--muted);
}
.imSprint {
  background: #f3f2ef;
}
.heute {
  border-color: var(--accent);
  font-weight: 700;
}
.sprintende::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 5px;
  width: 5px;
  height: 5px;
  margin-left: -2.5px;
  border-radius: 50%;
  background: var(--accent);
}
.gewaehlt,
.gewaehlt:hover:not(:disabled) {
  background: var(--black);
  color: var(--white);
}
.legende {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 6px;
  margin: 2px 0 0;
  font-size: 13px;
  color: var(--muted);
}
.legHeute,
.legSprint,
.legEnde {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  margin-left: 6px;
}
.legHeute {
  border: 2px solid var(--accent);
  margin-left: 0;
}
.legSprint {
  background: #e9e7e3;
}
.legEnde {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--accent);
}

@media (max-width: 640px) {
  .kalender {
    grid-template-columns: 1fr;
  }
  .schnell {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2px;
    border-right: 0;
    border-bottom: 1px solid var(--surface);
  }
  .schnell button {
    flex-direction: column;
    justify-content: center;
    gap: 0;
    padding: 4px 10px;
  }
}

/* Menü ⋯ (AUFGABEN-LISTE.md, Abschnitt 4) */
.mehrKnopf {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--target);
  height: var(--target);
  border: 0;
  border-radius: 10px;
  background: none;
  color: var(--muted);
  cursor: pointer;
}
.mehrKnopf:hover,
.mehrKnopf[aria-expanded="true"] {
  background: var(--surface);
  color: var(--text);
}
.mehrKnopf:focus-visible {
  outline: 3px solid var(--focus);
  outline-offset: 2px;
}
.menue {
  padding: 6px;
}
.menuePunkt {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: var(--target);
  padding: 0 10px;
  border: 0;
  border-radius: 10px;
  background: none;
  font: 500 14px var(--font);
  color: var(--text);
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
}
.menuePunkt:hover,
.menuePunkt:focus-visible {
  background: var(--surface);
  outline: none;
}
.menuePunkt:focus-visible {
  box-shadow: inset 0 0 0 2px var(--focus);
}
.menueGefahr {
  color: var(--danger);
}
.menueTrenner {
  border: 0;
  border-top: 1px solid var(--border);
  margin: 4px 0;
}
.menueKopf {
  padding: 8px 10px 12px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--border);
}
.menueHinweis {
  margin-left: auto;
  padding-left: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--muted);
}
